import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const edit_account_details = (accountData) => {
  // 后端使用POST方法，参数从Body JSON传递
  return api.post(`${ApiEndpointConstants.ADD_MERCHANT_ACCOUNT}`, {
    id: accountData.id,
    user_id: accountData.user_id,
    platform_type: accountData.platform_type,
    platform_name: accountData.platform_name,
    shop_name: accountData.shop_name,
    shop_url: accountData.shop_url,
    available_balance: accountData.available_balance,
    account_number: accountData.account_number,
    actual_number: accountData.actual_number,
    bank_location_country: accountData.bank_location_country,
    iban: accountData.iban,
    bic_code: accountData.bic_code,
    bank_name: accountData.bank_name,
    bank_sort_code: accountData.bank_sort_code,
    currency: accountData.currency,
    remark: accountData.remark,
  });
};
